import { render, staticRenderFns } from "./header-shop.vue?vue&type=template&id=53c9d2ac&"
import script from "./header-shop.vue?vue&type=script&lang=js&"
export * from "./header-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports